(function () {
  var LD = "TRWAGMYFPDXBNJZSQVHLCKE";   // resto mod 23 -> letra (Mº Interior)
  var LC = "JABCDEFGHI";                // dígito de control -> letra (CIF)
  var SOLO_LETRA  = "PQS";              // el control tiene que ser LETRA
  var SOLO_DIGITO = "ABEH";             // el control tiene que ser DÍGITO
  // el resto (C D F G J N R U V W K) admite letra o dígito
 
  function valida(v) {
    var s = (v || "").replace(/[\s.\-]/g, "").toUpperCase();
    // DNI
    if (/^\d{8}[A-Z]$/.test(s)) return s[8] === LD[parseInt(s.slice(0,8),10) % 23];
    // NIE  (X->0, Y->1, Z->2)
    if (/^[XYZ]\d{7}[A-Z]$/.test(s))
      return s[8] === LD[parseInt("XYZ".indexOf(s[0]) + s.slice(1,8), 10) % 23];
    // CIF
    var m = s.match(/^([A-HJ-NP-SUVW])(\d{7})([0-9A-J])$/);
    if (!m) return false;
    var total = 0;
    for (var i = 0; i < 7; i++) {
      var n = +m[2][i];
      if (i % 2 === 0) { n *= 2; if (n > 9) n -= 9; }
      total += n;
    }
    var d = (10 - (total % 10)) % 10;
    if (SOLO_LETRA.indexOf(m[1])  >= 0) return m[3] === LC[d];
    if (SOLO_DIGITO.indexOf(m[1]) >= 0) return m[3] === String(d);
    return m[3] === String(d) || m[3] === LC[d];
  }
 
  var FIELD_HINTS = [
    "company_tax_id",
    "tax_id",
    "cif",
    "nif",
    "nie",
    "numero de identificacion fiscal",
    "numero identificacion fiscal",
    "identificacion fiscal"
  ];
  var ERROR_ID = "dm-cif-nif-error";
  var ERROR_TEXT = "Revisa el CIF/NIF: el número no es válido.";

  function normalizaTexto(v) {
    return (v || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function escapeSelector(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function textoCampo(input) {
    var parts = [
      input.id,
      input.name,
      input.getAttribute("aria-label"),
      input.getAttribute("placeholder"),
      input.getAttribute("autocomplete")
    ];

    var form = input.closest("form") || input.ownerDocument;
    if (input.id && form && form.querySelector) {
      var label = form.querySelector('label[for="' + escapeSelector(input.id) + '"]');
      if (label) parts.push(label.textContent);
    }

    var container = input.closest(
      '[class*="formFieldContainer"], [class*="FormFieldContainer"], [class*="gridItem"], [class*="GridItem"], fieldset, div'
    );
    if (container) {
      var localLabel = container.querySelector("label, p, legend, [class*='label'], [class*='Label']");
      if (localLabel) parts.push(localLabel.textContent);
    }

    return normalizaTexto(parts.join(" "));
  }

  function pareceCampoFiscal(input) {
    if (!input || input.type === "hidden" || input.type === "submit") return false;
    var text = textoCampo(input);
    for (var i = 0; i < FIELD_HINTS.length; i++) {
      if (text.indexOf(FIELD_HINTS[i]) !== -1) return true;
    }
    return false;
  }

  function buscaInputFiscal(root) {
    if (!root || !root.querySelectorAll) return null;
    var inputs = root.querySelectorAll(
      'input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="submit"]), textarea'
    );

    for (var i = 0; i < inputs.length; i++) {
      if (pareceCampoFiscal(inputs[i])) return inputs[i];
    }

    return null;
  }

  function setFieldErrorState(input, hasError) {
    var container =
      input.closest('[class*="formFieldContainer"], [class*="FormFieldContainer"]') ||
      input.parentElement;
    if (!container || !container.classList) return;

    container.classList.toggle("withError", hasError);
  }

  function ensureError(input) {
    var scope = input.getRootNode && input.getRootNode();
    var err = scope && scope.querySelector ? scope.querySelector("#" + ERROR_ID) : null;
    if (!err) {
      err = document.createElement("output");
      err.id = ERROR_ID;
      err.setAttribute("role", "alert");
      err.className = "dm-cif-nif-error formError";
      err.style.display = "none";
      err.textContent = ERROR_TEXT;
    }

    var container =
      input.closest('[class*="formFieldContainer"], [class*="FormFieldContainer"]') ||
      input.parentElement;
    var label = container && input.id
      ? container.querySelector('label[for="' + escapeSelector(input.id) + '"]')
      : null;

    if (label) {
      label.insertAdjacentElement("afterend", err);
    } else if (container) {
      container.appendChild(err);
    } else {
      input.insertAdjacentElement("afterend", err);
    }

    return err;
  }

  function bindForm(form, root) {
    if (!form || form.dataset.dmCifNifValidation === "true") return;

    var input = buscaInputFiscal(form) || buscaInputFiscal(root);
    if (!input) return;

    var err = ensureError(input);

    function comprueba() {
      var v = input.value.trim();
      if (!v) {
        err.style.display = "none";
        input.setAttribute("aria-invalid", "false");
        setFieldErrorState(input, false);
        return true;
      }

      var ok = valida(v);
      err.style.display = ok ? "none" : "block";
      input.setAttribute("aria-invalid", ok ? "false" : "true");
      setFieldErrorState(input, !ok);
      return ok;
    }

    function bloqueaSiInvalido(e) {
      if (comprueba()) {
        input.value = input.value.replace(/[\s.\-]/g, "").toUpperCase();
        return true;
      }

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      input.focus();
      return false;
    }

    input.addEventListener("blur", comprueba);
    input.addEventListener("input", function () {
      err.style.display = "none";
      input.setAttribute("aria-invalid", "false");
      setFieldErrorState(input, false);
    });

    form.addEventListener("submit", bloqueaSiInvalido, true);
    form.addEventListener("click", function (e) {
      var target = e.target && e.target.closest ? e.target : null;
      var submit = target && target.closest('button[data-testid="btn-form-submit"], button[type="submit"], [type="submit"]');
      if (submit && form.contains(submit)) bloqueaSiInvalido(e);
    }, true);

    form.dataset.dmCifNifValidation = "true";
  }

  function bindRoot(root) {
    if (!root || !root.querySelectorAll) return;

    if (root !== document && !root.__dmCifNifObserver) {
      root.__dmCifNifObserver = new MutationObserver(function () {
        bindRoot(root);
      });
      root.__dmCifNifObserver.observe(root, {
        childList: true,
        subtree: true
      });
    }

    var forms = root.querySelectorAll("form");
    for (var i = 0; i < forms.length; i++) {
      bindForm(forms[i], root);
    }

    var embeds = root.querySelectorAll("shopify-forms-embed");
    for (var j = 0; j < embeds.length; j++) {
      if (embeds[j].shadowRoot) bindRoot(embeds[j].shadowRoot);
    }
  }

  function init() {
    bindRoot(document);

    var observer = new MutationObserver(function () {
      bindRoot(document);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      bindRoot(document);
    }, 1000);

    setTimeout(function () {
      bindRoot(document);
    }, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
